const ModuleModel = {
    empty_module_model : {   
        plot_id: null,
        name: null,
        installation_date: null,
        longitude: null,
        latitude: null,
        enabled: true
    },
    module_params_read_model : {
        post_flow_meter_trees: 0,
        soil_moisture_max_optimal_region_percentage: 0,
        soil_moisture_min_optimal_region_percentage: 0,
        soil_moisture_shallow_depth: {
            enabled: false,
            depth: 0,
            distance_to_dropper: 0,
            min: 0,
            max: 0
        },
        soil_moisture_intermediate_depth: {
            enabled: false,
            depth: 0,
            distance_to_dropper: 0,
            min: 0,
            max: 0
        },
        soil_moisture_greater_depth: {
            enabled: false,
            depth: 0,
            distance_to_dropper: 0,
            min: 0,
            max: 0
        } 
    }
};

export default ModuleModel;